// 404 fallback for any path the router can't match. Rendered inside the
// Layout shell so the user still has the wordmark + sign-out to escape with.

import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center p-8 min-h-[calc(100vh-3.5rem)] text-center">
      <p className="orb-eyebrow mb-3">404 · off course</p>
      <h1 className="font-display text-3xl font-semibold text-fg mb-2">
        That page isn't on the star chart yet.
      </h1>
      <p className="text-fg-muted text-sm mb-6 max-w-sm">
        Phase-1 wires up the dashboard and the projects list. Scans, issues,
        and rules land in tickets T031–T034.
      </p>
      <Link
        to="/"
        className="
          inline-flex items-center gap-2 px-4 py-2 rounded-md
          text-xs font-semibold uppercase tracking-[0.08em]
          text-accent border border-accent/30 hover:bg-accent/10
          transition-colors
        "
      >
        Back to dashboard
      </Link>
    </div>
  );
}
